/* eslint-disable camelcase */
import { gql } from '@apollo/client'

export type {
  FieldsSettings as Fields,
  FieldsSettingsVariables,
  FieldsSettings_fields_Fields_results_Field as Field,
} from './types/index.graphql'
export type {
  SeasonsSettings as Seasons,
  SeasonsSettingsVariables,
  SeasonsSettings_seasons_Seasons_results_Season as Season,
} from './types/index.graphql'
export type { DeleteLot, DeleteLotVariables } from './types/index.graphql'

export const FIELDS_SETTINGS = gql`
  query FieldsSettings($companyId: Int!) {
    fields(companyId: $companyId) {
      results {
        id
        name
        productionType
        deliveryCondition
      }
    }
  }
`

export const SEASONS_SETTINGS = gql`
  query SeasonsSettings($companyId: Int!) {
    seasons(companyId: $companyId) {
      results {
        id
        name
      }
    }
  }
`

export const DELETE_LOT = gql`
  mutation DeleteLot($id: Int!) {
    deleteLot(id: $id) {
      success
    }
  }
`
